import { FileExtension, IFileExtensionContext } from 'tessa/ui/files';
import { CdCardTypes } from '../Helpers/CdCardTypes';

export class PkTCOfferContextMenuFileExtension extends FileExtension {
  public async openingMenu(context: IFileExtensionContext) {
    let card = context.control.model.card;
    let files = context.files;

    if (card.typeId != CdCardTypes.PkTCOfferTypeID) {
        return;
    }

    let pkFilesPermissionsVirtual = card.sections.getOrAdd("PkFilesPermissionsVirtual");
    let prohibitedCategories = new Array();
    pkFilesPermissionsVirtual.rows.forEach(r => {
        if (!r.tryGet("AllowAdd")) {
            let category = {CategoryID: r.tryGet("FileCategoryID")};
            prohibitedCategories.push(category);
        }
    });

    let createCopyAction = context.actions.find(a => a.name == "MakeCopy")!;
    let showVersionsAction = context.actions.find(a => a.name == "ShowVersions")!;
    if (!createCopyAction || !showVersionsAction) {
        return;
    }

    files.forEach(f => {
        if (prohibitedCategories.find(c => c.CategoryID == f.model.category?.id)) {
            createCopyAction.isCollapsed = true;
            showVersionsAction.isCollapsed = true;
        }
    });
  }
}